module.exports = __webpack_public_path__ + "static/media/chat2_darkbleu.fc677347.svg";